import { CircularProgress, LinearProgress, Tab, Tabs } from "@mui/material";
import QuestionnaireDetails from "./QuestionnaireDetails";
import Ajax from "../../../Ajax";
import React from "react";
import { store } from "../../../stores/Store";
import { Alert } from "../../..";
import QuestionnaireAnswers from "./QuestionnaireAnswers";
import QuestionnairePreloadedAnswers from "./QuestionnairePreloadedAnswers";
import QuestionnaireUploads from "./QuestionnaireUploads";
import FormFields from "./template_reader/FormFields";
import { observer } from "mobx-react-lite";
import { Icons } from "../../../misc/Icons";


interface ViewQuestionnaireProps {
    uid: string;
}


export default observer(function ViewQuestionnaire ({uid}: ViewQuestionnaireProps) {

    const { questionnaire, getQuestionnaire } = store.QuestionnaireStore
    const [loading, setLoading] = React.useState(true)
    const [tab, setTab] = React.useState("details")
    
    React.useEffect(() => {
        getQuestionnaire(uid).then(() => {
            setLoading(false)
        })
    }, [])

    if (!questionnaire || loading) {
        return (
            <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                <CircularProgress style={{width: "14px", height: "14px", margin: "0"}} />
                <p>Loading Questionnaire</p>
            </div>
        )
    }

    return (
        <div className="form">
            <div style={{display: "flex", justifyContent: "space-between", marginBottom: "15px"}}>
                <h2>Questionnaire</h2>
                
                <Tabs value={tab} onChange={(e, value) => setTab(value)}>
                    <Tab label="Details" value="details" />
                    <Tab label="Settings" value="settings" />
                    <Tab label="Answers" value="answers" />
                    <Tab label="Preloaded answers" value="preloadedAnswers" />
                    
                    {questionnaire.uploads?.length ? (
                        <Tab label="Attachments" value="attachments" />
                    ) : null}
                </Tabs>
            </div>

            {tab === "details" ? (
                <QuestionnaireDetails />
            ) : null}

            {tab === "settings" ? (
                <QuestionnaireSettings />
            ) : null}

            {tab === "answers" ? (
                <QuestionnaireAnswers />
            ) : null}

            {tab === "preloadedAnswers" ? (
                <QuestionnairePreloadedAnswers />
            ) : null}

            {tab === "attachments" ? (
                <QuestionnaireUploads />
            ) : null}
        </div>
    )
})



function QuestionnaireSettings () {

    const { questionnaire } = store.QuestionnaireStore
    const [loading, setLoading] = React.useState(false)
    const [saved, setSaved] = React.useState(false)
    const template = JSON.parse(questionnaire.template.json)
    const answers = JSON.parse(questionnaire.answers)

    const submit = async (values) => {
        setLoading(true)

        await Ajax.Questionnaire.PatchAnswers(questionnaire.uid, values).then((response) => {
            store.QuestionnaireStore.getQuestionnaire(questionnaire.uid)
            setSaved(true)
        }).catch((response) => {
            Alert({message: response.data?.detail, color: "error"})
        })
        
        setLoading(false)
    }

    if (!template.settings) {
        return <p>This Questionnaire type has no settings.</p>
    }

    return (
        <div className={loading ? "disabled" : ""}>
            <FormFields
                initialValues={answers}
                fields={template.settings.fields} 
                submitButtonText="Save Settings"
                onChange={async (formik) => {
                    setSaved(false)
                }}
                onSubmit={async (settingsAnswers) => {
                    var newPayload = {...settingsAnswers, answers: answers}
                    
                    await submit(newPayload)
                }} />

            {saved ? (
                <div style={{display: "flex", gap: "4px", alignItems: "center", marginTop: "10px"}}>
                    <Icons.Tick style={{color: "green", fontSize: "14px"}} />
                    <small>Settings saved successfully</small>
                </div>
            ) : null}
        </div>
    )
}